import clsx from 'clsx'
import React from 'react'

import { BadgeCell } from './BadgeCell'
import { BadgeRow } from './BadgeRow'
import { Cell } from './Cell'
import { ColumnHeader } from './ColumnHeader'
import { Head } from './Head'
import { HeadRow } from './HeadRow'
import { Row } from './Row'
import { Section } from './Section'

interface PlanTableProps extends Omit<React.HTMLAttributes<HTMLTableElement>, 'className'> {
  children: React.ReactNode;
  layout?: 'fixed' | 'auto'
}

export function PlanTable ({ children, layout, ...props }: PlanTableProps) {
  return (
    <table
      {...props}
      className={clsx('body-sm text-gray-800 w-full border-separate border-spacing-0', {
        'table-fixed': layout === 'fixed',
      })}
    >
      {children}
    </table>
  )
}

PlanTable.BadgeCell = BadgeCell
PlanTable.BadgeRow = BadgeRow
PlanTable.Cell = Cell
PlanTable.ColumnHeader = ColumnHeader
PlanTable.Head = Head
PlanTable.HeadRow = HeadRow
PlanTable.Row = Row
PlanTable.Section = Section
